import React from 'react';

export default function StatCard({ label, value, sub, color, icon }) {
  return (
    <div style={{
      background: 'rgba(30,45,79,0.5)',
      borderRadius: '12px',
      border: `1px solid ${color}25`,
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    }}>
      <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'8px' }}>
        <span style={{ fontSize:'16px', color }}>{icon}</span>
        <span style={{ fontFamily:'Inter', fontSize:'12px', color:'#5B7BA8', textTransform:'uppercase', letterSpacing:'0.5px' }}>{label}</span>
      </div>
      <div style={{ fontFamily:'Space Grotesk', fontSize:'28px', fontWeight:700, color, lineHeight:1 }}>
        {value}
      </div>
      {sub && <div style={{ fontFamily:'Inter', fontSize:'12px', color:'#5B7BA8', marginTop:'4px' }}>{sub}</div>}
    </div>
  );
}
